module.exports = __webpack_public_path__ + "img/white-filter-icon.ffa422ef.svg";